<div class="container table-page">
  @if (isLoading) {
  <aw-spinner [fullScreen]="true"></aw-spinner>
  }
  <aw-toast></aw-toast>
  <aw-divider
    [inset]="false"
    [middleInset]="false"
    [title]="'Third-Party Employee Management'"
    [altColor]="false"
  >
  </aw-divider>

  <!-- Bar and table together, so the bar sits 8px above the table rather than a .container gap away. -->
  <div class="table-section">
    <app-table-action-bar>
      <aw-search
        class="table-action-bar__search"
        [(ngModel)]="searchInputValue"
        (ngModelChange)="onSearchInput(searchInputValue)"
        [placeholder]="'Search'"
        ariaLabel="Search Third-Party Employees"
        [searchOptions]="selectionOptions"
      >
        <mat-icon [svgIcon]="'search'" position="prefix"></mat-icon>
      </aw-search>

      <aw-select-menu
        class="table-action-bar__filter"
        ariaLabel="Filter on Status"
        placeholder="Filter on Status"
        [formControl]="statusFilter"
        [multiSelectListItems]="statusFilterOptions"
      >
        <aw-form-field-label>Status</aw-form-field-label>
      </aw-select-menu>

      @if (userPermissions['canEdit']) {
      <button
        type="button"
        AwButton
        [buttonType]="'outlined'"
        [disable]="disableChangeStatus"
        (click)="openChangeStatusMultipleDialog = true"
      >
        Change Status
      </button>
      } @if (userPermissions['canDelete']) {
      <button
        type="button"
        AwButton
        [buttonType]="'outlined'"
        [disable]="disableDeleteEmployee"
        (click)="openDeleteMultipleEmployeesDialog = true"
      >
        Delete
      </button>
      } @if (userPermissions['canCreate']) {
      <button
        type="button"
        class="table-action-bar__end"
        AwButton
        [buttonType]="'primary'"
        (click)="openAddEmployee()"
      >
        Add Third-Party Employee
      </button>
      }
    </app-table-action-bar>

    <!-- Re-created across the phone breakpoint: aw-table reads its scroll mode once, on init. -->
    @for (mode of [isPhone() ? 'phone' : 'desktop']; track mode) {
      <aw-table
        [columnsDefinition]="columnsDefinition"
        [tableData]="tableData()"
        [tableHeight]="isPhone() ? '' : '100%'"
        [enableInfiniteScroll]="!isPhone()"
        [displayableRowsCount]="50"
        [enableStickyOptions]="enableStickyOptions()"
        [optionsMenu]="optionsMenu"
        [sortDisabled]="sortDisabled()"
        (checkboxList)="checkBoxActionHandler($event)"
        (optionsMenuClicked)="handleActionMenu($event)"
      >
      </aw-table>
    }
    <aw-footer [resultsCount]="tableData().length"></aw-footer>
    <app-results-status [count]="tableData().length"></app-results-status>
  </div>

  <aw-dialog
    [visible]="openChangeStatusMultipleDialog"
    [formFieldsData]="formFieldsData()"
    [dialogOptions]="dialogOptionsStatus"
    (primaryAction)="dialogFormValuesHandler($event, 'status-multiple')"
    (secondaryAction)="dialogCloseHandler('status-multiple')"
    ariaLabel="Change Third-Party Employees Status"
  >
  </aw-dialog>

  <aw-dialog
    [visible]="openChangeStatusSingleDialog"
    [formFieldsData]="formFieldsData()"
    [dialogOptions]="dialogOptionsStatus"
    (primaryAction)="dialogFormValuesHandler($event, 'status-single')"
    (secondaryAction)="dialogCloseHandler('status-single')"
    ariaLabel="Change Third-Party Employee Status"
  >
  </aw-dialog>

  <aw-dialog
    [visible]="openDeleteMultipleEmployeesDialog"
    [dialogOptions]="dialogOptionsDelete"
    (primaryAction)="dialogFormValuesHandler($event, 'delete-multiple')"
    (secondaryAction)="dialogCloseHandler('delete-multiple')"
    ariaLabel="Delete Third-Party Employees"
  >
  </aw-dialog>
  <aw-dialog
    [visible]="openDeleteEmployeeDialog"
    [dialogOptions]="dialogOptionsDelete"
    (primaryAction)="dialogFormValuesHandler($event, 'delete-single')"
    (secondaryAction)="dialogCloseHandler('delete-single')"
    ariaLabel="Delete Third-Party Employee"
  >
  </aw-dialog>
</div>
